module.exports = __webpack_public_path__ + "img/Zwono_Logo-H-Colors-RGB-228x70.ccd52bd2.svg";